/**
 * Live Casino vendor dashboard display helpers.
 * Settlement nets are always INR major; POINTS display = ÷100 (1 pt = ₹100).
 */

import { money } from '@/lib/format'

/** Normalize row currency; empty → INR. */
export function liveCasinoRowCurrency(currency?: string | null): string {
  const c = String(currency ?? '').trim()
  return c || 'INR'
}

/**
 * KPI currency for Final Outcome Amount.
 * Single-currency page → that currency; mixed or empty → INR fallback
 * (sum is INR majors; avoid showing Pts for a mixed-tree total).
 */
export function liveCasinoPageCurrency(
  rows: ReadonlyArray<{ currency?: string | null }>,
): string {
  if (!rows.length) return 'INR'
  const first = liveCasinoRowCurrency(rows[0]!.currency)
  const uniform = rows.every((r) => liveCasinoRowCurrency(r.currency) === first)
  return uniform ? first : 'INR'
}

/** Per-row Net cell — signed, currency-aware (POINTS ÷100). */
export function formatLiveCasinoNet(
  winLoseAmt: number,
  currency?: string | null,
): string {
  return money(winLoseAmt, {
    signed: true,
    currency: liveCasinoRowCurrency(currency),
  })
}

/** Final Outcome KPI — signed; uses page currency (mixed → INR). */
export function formatLiveCasinoFinalOutcome(
  finalOutcomeAmount: number,
  rows: ReadonlyArray<{ currency?: string | null }>,
): string {
  return money(finalOutcomeAmount, {
    signed: true,
    currency: liveCasinoPageCurrency(rows),
  })
}
